import { useTranslation } from 'react-i18next';

import { useValuePropPreferencesQuery } from '../../../../features/preferences/useValuePropPreferencesQuery';

import { OnboardingStep } from './Onboarding';

const fallbackSubtitleKey = 'insights.onboarding.fallback_subtitle';

const propsByStep: Record<OnboardingStep, { titleKey: string; subtitleKey: string }> = {
  [OnboardingStep.painPoint]: {
    titleKey: 'insights.onboarding.pain_point.title',
    subtitleKey: 'insights.onboarding.pain_point.subtitle',
  },
  [OnboardingStep.valueProposition]: {
    titleKey: 'insights.onboarding.value_proposition.title',
    subtitleKey: 'insights.onboarding.pain_point.subtitle',
  },
  [OnboardingStep.metrics]: {
    titleKey: 'insights.onboarding.metrics.title',
    subtitleKey: 'insights.onboarding.metrics.subtitle',
  },
  [OnboardingStep.countries]: {
    titleKey: 'insights.onboarding.countries.title',
    subtitleKey: 'insights.onboarding.countries.subtitle',
  },
};

export const useStepTexts = (step: OnboardingStep) => {
  const { data: vpAndPp, isLoading: isLoadingVpAndPp } = useValuePropPreferencesQuery();
  const { t } = useTranslation();

  const { titleKey, subtitleKey } = propsByStep[step];

  const getSubtitle = () => {
    if (isLoadingVpAndPp) {
      return '';
    }

    if (step === OnboardingStep.painPoint || step === OnboardingStep.valueProposition) {
      const hasSuggestedValue = !!vpAndPp?.default[step];
      const key = hasSuggestedValue ? subtitleKey : fallbackSubtitleKey;
      return t(key);
    }

    return t(subtitleKey);
  };

  return { title: t(titleKey), subtitle: getSubtitle() };
};
